import { UsersInShopSectionProps } from './users-in-shop-section.types'
import styles from './users-in-shop-section.module.scss'
import { SectionContainer, H2, NoneLabel } from '@touche-lts/panel-ui/dist'
import { UsersSearchInput } from './users-search-input'
import { UsersInStoreTable } from './users-in-shop-table'
import { Alert } from 'react-bootstrap'
import { useRootStore } from 'mobx-stores/store-provider'
import { observer } from 'mobx-react-lite'

const UsersInShopSectionComponent = (props: UsersInShopSectionProps) => {
  const {
    addedUsers,
    onRemoveUserClick,
    ...sectionContainerProps
  } = props,
  {
    viewStorePageStore: {
      newUserAdded
    }
  } = useRootStore()

  return (
    <SectionContainer {...sectionContainerProps}>
      <div className={styles.headerContainer}>
        <H2>Users in shop</H2>
        <UsersSearchInput excludeUsersFromSearchResults={addedUsers} />
      </div>
      {newUserAdded && (
      <Alert className='mt-3' variant="success">
        <Alert.Heading>New user added successfully!</Alert.Heading>
      </Alert>
      )}
      {Boolean(addedUsers?.length) ? (
        <UsersInStoreTable
          users={addedUsers}
          onRemoveUserClick={onRemoveUserClick}
        />
      ) : (
        <NoneLabel label='No users added yet to this store.' />
      )}
    </SectionContainer>
  )
}

const UsersInShopSection = observer(UsersInShopSectionComponent)
export { UsersInShopSection }
